module.exports = __webpack_public_path__ + "static/media/STEP-03.a2aded4d.png";